"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var react_redux_1 = require("react-redux");
var HudledHelmet_1 = __importDefault(require("containers/App/HudledHelmet"));
var Heading_1 = __importDefault(require("shared/components/Heading"));
var HoCs_1 = require("utils/HoCs");
var selectors_1 = require("../selectors");
var AuditCallout_1 = __importDefault(require("./components/AuditCallout"));
var Benchmarks_1 = __importDefault(require("./components/Benchmarks"));
var ReportBenchmark = function () {
    var audit = (0, react_redux_1.useSelector)(selectors_1.selectLatestAudit);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(HudledHelmet_1.default, { title: "Hudled - Saas Audit Benchmark Report", description: "Saas Audit Benchmark Report" }), (0, jsx_runtime_1.jsx)(AuditCallout_1.default, {}), (0, jsx_runtime_1.jsx)(material_1.Box, __assign({ position: "relative", width: "100%" }, { children: (0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ pt: 3, pb: 2, height: "100%", maxWidth: 800 }, { children: [(0, jsx_runtime_1.jsx)(Heading_1.default, __assign({ level: 1 }, { children: "Benchmarks" })), audit && (0, jsx_runtime_1.jsx)(Benchmarks_1.default, { audit: audit })] })) }))] }));
};
exports.default = (0, HoCs_1.HasCompanyHoC)(ReportBenchmark);
